import { Record } from 'immutable';

export default class SignableDocumentRecord extends Record({
  id: undefined,
  title: undefined,
  description: undefined,
  creationMethod: undefined,
  content: undefined,
  generatedHtml: undefined,
  status: undefined,
  createdAt: undefined,
  sentAt: undefined,
  openedAt: undefined,
  signedAt: undefined,
  createdBy: undefined,
  resource: undefined,
  bankidPersonalNumber: undefined,
  bankidOrderRef: undefined,
  files: undefined,
  links: undefined,
  _type: undefined,
}) {
}
